import { useSelectorPromoVideoCountryCodes } from '../../../../configuration/configuration.selectors';

type UseIsValidCountryProps = {
    countryCode: string | undefined
};

export const useIsValidCountry = ({ countryCode = '' }: UseIsValidCountryProps) => {
    const promoVideoCountryCodes = useSelectorPromoVideoCountryCodes();

    return promoVideoCountryCodes.includes(countryCode);
};
